import { IGlowModelVal } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { BasePresetUtil, EMPTY_EFFECT } from './base-preset-util';
import * as ICON from '../glow-preset-menu/preset-icons';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import _isEmpty from 'lodash/isEmpty';

const PresetIconOnShow = {
    [EMPTY_EFFECT]: ICON.DrawerEMPTY,
    'glow-1': ICON.DrawerGlow1,
    'glow-2': ICON.DrawerGlow2,
    'glow-3': ICON.DrawerGlow3,
    'glow-4': ICON.DrawerGlow4,
    'glow-5': ICON.DrawerGlow5,
    'glow-6': ICON.DrawerGlow6,
    'glow-7': ICON.DrawerGlow7,
    'glow-8': ICON.DrawerGlow8,
    'glow-9': ICON.DrawerGlow9,
};

const DefaultGlowProps = {
    color: '#0E0E0E',
    opacity: 0,
    size: 0,
    tdColor: new TDColor({
        rgbaStr: '#0E0E0E',
    }),
};

export class GlowPresetUtil extends BasePresetUtil {
    protected presetIcon = PresetIconOnShow;
    protected defaultEffectProps = DefaultGlowProps;

    protected getIconName(info: IGlowModelVal): string {
        if (_isEmpty(info)) return EMPTY_EFFECT;
        const { size, tdColor } = info;
        if (size === 0) return EMPTY_EFFECT;
        return `glow-${tdColor?.colorValue}-${size}`;
    }
}
